import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import './ToolPage.css'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

const generateUuid = () =>
  window.crypto.randomUUID
    ? window.crypto.randomUUID()
    : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (window.crypto.getRandomValues(new Uint8Array(1))[0]) % 16
      const v = c === 'x' ? r : (r & 0x3) | 0x8
      return v.toString(16)
    })

const UuidGenerator = () => {
  useDocumentMeta({
    title: 'Gerador de UUID Online (v4)  jarder.dev',
    description:
      'Gere UUIDs v4 aleatórios e válidos, um ou vários de uma vez. ' +
      'Grátis, direto no navegador, sem cadastro.',
  })

  const [count, setCount] = useState('5')
  const [uuids, setUuids] = useState(() =>
    Array.from({ length: 5 }, generateUuid),
  )
  const [copied, setCopied] = useState(false)

  const generate = () => {
    const n = Math.max(1, Math.min(Number.parseInt(count, 10) || 1, 100))
    setUuids(Array.from({ length: n }, generateUuid))
    trackEvent('tool_generate', { tool: 'uuid', count: n })
  }

  const copyAll = () => {
    navigator.clipboard.writeText(uuids.join('\n')).then(() => {
      setCopied(true)
      trackEvent('tool_copy', { tool: 'uuid' })
      setTimeout(() => setCopied(false), 1500)
    })
  }

  return (
    <div className="tool-page">
      <Link to="/ferramentas" className="tool-back-link">
        ← Todas as ferramentas
      </Link>
      <h1>Gerador de UUID</h1>
      <p className="tool-disclaimer">
        UUIDs versão 4 (aleatórios), gerados com{' '}
        <code>crypto.randomUUID</code> direto no seu navegador.
      </p>

      <div className="tool-row">
        <div className="tool-field">
          <label htmlFor="count">Quantos gerar</label>
          <input
            id="count"
            type="number"
            min="1"
            max="100"
            value={count}
            onChange={(e) => setCount(e.target.value)}
          />
        </div>
      </div>

      <div className="tool-result-actions" style={{ marginBottom: 20 }}>
        <button type="button" className="tool-button" onClick={generate}>
          Gerar
        </button>
        <button
          type="button"
          className="tool-button tool-button-secondary"
          onClick={copyAll}
        >
          Copiar todos
        </button>
        {copied && <span className="tool-copied">Copiado!</span>}
      </div>

      <ul className="tool-list">
        {uuids.map((uuid, i) => (
          <li key={`${uuid}-${i}`}>{uuid}</li>
        ))}
      </ul>

      <div className="tool-info-section">
        <h2>Para que serve um UUID</h2>
        <p>
          Um UUID (identificador único universal) é um número de 128
          bits praticamente impossível de colidir com outro gerado em
          qualquer lugar do mundo, mesmo sem coordenação central. É muito
          usado como chave primária em bancos de dados, identificador de
          sessão, nome de arquivo temporário ou ID de registro em
          sistemas distribuídos, onde gerar IDs sequenciais em várias
          máquinas ao mesmo tempo seria complicado.
        </p>
      </div>
    </div>
  )
}

export default UuidGenerator
